export default "__VITE_ASSET__Buc28922__"